/**
 * Formats a duration in seconds into a locale-aware string using Intl.DurationFormat.
 *
 * @param {number} timeInSeconds - Duration in seconds
 * @param {string} locale - BCP 47 locale tag (e.g. 'en', 'he')
 * @param {'long'|'short'|'narrow'|'digital'} style - Display style
 * @returns {string}
 */
export const formatTime = (timeInSeconds, locale = 'en', style = 'short') => {
  if (!timeInSeconds) return '';

  const seconds = Math.floor(timeInSeconds);

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  let duration = { seconds: secs };
  if (days) duration = { days, hours };
  else if (hours) duration = { hours, minutes };
  else if (minutes) duration = { minutes, seconds: secs };

  return new Intl.DurationFormat(locale, { style }).format(duration);
};
